import React, { useEffect, useState } from "react";
import ClientSettingSaveButton from "./ClientSettingSaveButton";

const SelfReferralConfigRow = ({ api, setting, clientID }) => {
    useEffect(() => {
        setValue(setting.SettingValue);
        setInitialValue(setting.SettingValue);
    }, [setting]);

    const { SettingKey, SettingValue, SettingDescription, DefaultValue } = setting;

    const [initialValue, setInitialValue] = useState(SettingValue);
    const [value, setValue] = useState(SettingValue);
    const [apiError, setApiError] = useState("");

    const isChanged = value !== initialValue;
    const isDefault = initialValue === DefaultValue;

    const editButtonHandler = dlt => {
        const param = {
            SettingKey: SettingKey,
            ClientID: clientID,
            SettingValue: value,
            Delete: dlt
        };

        api.transact("SaveBrandingInfo", param)
            .then(() => {
                setInitialValue(value);
                setApiError("");
                if (dlt) {
                    setValue(DefaultValue);
                    setInitialValue(DefaultValue);
                }
            })
            .catch(e => {
                setApiError(e.message);
            });
    };

    return (
        <div>
            <div className="configRow selfReferralConfigRow">
                <div className="configLabel">{SettingKey ?? SettingDescription}</div>

                <div className="configValue">
                    <input value={value} onChange={e => setValue(e.target.value)} />
                </div>

                <div className="configDescription">{SettingDescription}</div>

                <div className="configActions">
                    <ClientSettingSaveButton
                        isChanged={isChanged}
                        isDefault={isDefault}
                        editButtonHandler={editButtonHandler}
                    />
                </div>
            </div>

            {apiError && <p style={{ color: "red" }}>{apiError}</p>}
        </div>
    );
};

export default SelfReferralConfigRow;
